export { FolderPlus } from './folder-plus-deprecated';
export { PictureInPicture } from './picture-in-picture-deprecated';
export { SvgAccount } from './account';
export { SvgAccountCircle } from './account-circle';
export { SvgActionItem } from './actionItem';
export { SvgAdd } from './add';
export { SvgAddAPhoto } from './add-a-photo';
export { SvgAddCircleOutline } from './add-circle-outline';
export { SvgAddClip } from './add-clip';
export { SvgAddPhoto } from './add-photo';
export { SvgAdmin } from './admin';
export { SvgAiGenerativeAudio } from './ai-generative-audio';
export { SvgAlertTriangle } from './alert-triangle';
export { SvgAlertBulb } from './alert-bulb';
export { SvgAlignBottom } from './align-bottom';
export { SvgAlignCenter } from './align-center';
export { SvgAlignLeft } from './align-left';
export { SvgAlignRight } from './align-right';
export { SvgApple } from './apple';
export { SvgApps } from './apps';
export { SvgArchive } from './archive';
export { SvgArrowBack } from './arrow-back';
export { SvgArrowDownward } from './arrow-downward';
export { SvgArrowDropDown } from './arrow-drop-down';
export { SvgArrowDropUp } from './arrow-drop-up';
export { SvgArrowForward } from './arrow-forward';
export { SvgArrowLeft } from './arrow-left';
export { SvgArrowLeftAlt } from './arrow-left-alt';
export { SvgArrowRight } from './arrow-right';
export { SvgArrowRightAlt } from './arrow-right-alt';
export { SvgArrowSlanted } from './arrow-slanted';
export { SvgArrowUpward } from './arrow-upward';
export { SvgAtlassian } from './atlassian';
export { SvgAtMention } from './at-mention';
export { SvgAutoChapters } from './auto-chapters';
export { SvgAutoDraft } from './auto-draft';
export { SvgAutoSummaries } from './auto-summaries';
export { SvgAutoTitles } from './auto-titles';
export { SvgBack } from './back';
export { SvgBack5 } from './back5';
export { SvgBannerVectorUp } from './banner-vector-up';
export { SvgBarChart } from './bar-chart';
export { SvgBell } from './bell';
export { SvgBellOff } from './bell-off';
export { SvgBellRing } from './bell-ring';
export { SvgBlur } from './blur';
export { SvgBold } from './bold';
export { SvgBook } from './book';
export { SvgBorderColor } from './border-color';
export { SvgBug } from './bug';
export { SvgBulb } from './bulb';
export { SvgCalendly } from './calendly';
export { SvgCalendar } from './calendar';
export { SvgCallToAction } from './call-to-action';
export { SvgCamera } from './camera';
export { SvgCamBubble } from './cam-bubble';
export { SvgCamBubbleSmall } from './cam-bubble-small';
export { SvgCanvas } from './canvas';
export { SvgCaptions } from './captions';
export { SvgCaretFolder } from './caret-folder';
export { SvgCCOff } from './cc-off';
export { SvgCCOn } from './cc-on';
export { SvgChart } from './chart';
export { SvgCheck } from './check';
export { SvgCheckCircle } from './check-circle';
export { SvgCheckCircleFill } from './check-circle-fill';
export { SvgCheckCircleOutline } from './check-circle-outline';
export { SvgCheckCircleSmall } from './check-circle-small';
export { SvgChevronDown } from './chevron-down';
export { SvgChevronLeft } from './chevron-left';
export { SvgChevronRight } from './chevron-right';
export { SvgChevronsLeft } from './chevrons-left';
export { SvgChevronSmallLeft } from './chevron-small-left';
export { SvgChevronSmallRight } from './chevron-small-right';
export { SvgChevronSmallUp } from './chevron-small-up';
export { SvgChevronsRight } from './chevrons-right';
export { SvgChevronUp } from './chevron-up';
export { SvgChrome } from './chrome';
export { SvgChromeLogo } from './chrome-logo';
export { SvgClip } from './clip';
export { SvgClock } from './clock';
export { SvgClose } from './close';
export { SvgCode } from './code';
export { SvgCollapse } from './collapse';
export { SvgCollapseReplies } from './collapse-replies';
export { SvgColorLens } from './color-lens';
export { SvgColorNone } from './color-none';
export { SvgComment } from './comment';
export { SvgCommentAdd } from './comment-add';
export { SvgConfetti } from './confetti';
export { SvgConfluence } from './confluence';
export { SvgConfluenceInverse } from './confluence-inverse';
export { SvgConfluenceNeutral } from './confluence-neutral';
export { SvgContactSupport } from './contact-support';
export { SvgCopy } from './copy';
export { SvgCopyPlus } from './copy-plus';
export { SvgCreate } from './create';
export { SvgCreateTicket } from './create-ticket';
export { SvgCrop169 } from './crop-16-9';
export { SvgCrop169Expanded } from './crop169-expanded';
export { SvgCropExpanded169 } from './crop-expanded-16-9';
export { SvgCropTool } from './crop-tool';
export { SvgCut } from './cut';
export { SvgCursor } from './cursor';
export { SvgDelete } from './delete';
export { SvgDeleteForever } from './delete-forever';
export { SvgDesktopMac } from './desktop-mac';
export { SvgDevices } from './devices';
export { SvgDiagramSymbolDecision } from './diagram-symbol-decision';
export { SvgDomain } from './domain';
export { SvgDownload } from './download';
export { SvgEdgeLogo } from './edge-logo';
export { SvgEdit } from './edit';
export { SvgEditions } from './editions';
export { SvgEditBorder } from './edit-border';
export { SvgExitToApp } from './exit-to-app';
export { SvgExpand } from './expand';
export { SvgExpandReplies } from './expand-replies';
export { SvgExtension } from './extension';
export { SvgExternalLink } from './external-link';
export { SvgEye } from './eye';
export { SvgEyeOff } from './eye-off';
export { SvgFacebook } from './facebook';
export { SvgFiberManualRecord } from './fiber-manual-record';
export { SvgFillerWordRemoval } from './filler-word-removal';
export { SvgFirefoxLogo } from './firefox-logo';
export { SvgFirstPage } from './first-page';
export { SvgFolder } from './folder';
export { SvgFolderShared } from './folder-shared';
export { SvgForward } from './forward';
export { SvgForward5 } from './forward5';
export { SvgFullscreen } from './fullscreen';
export { SvgFullscreenExit } from './fullscreen-exit';
export { SvgFullScreen2 } from './full-screen';
export { SvgGlobe } from './globe';
export { SvgGoogle } from './google';
export { SvgGoogleCalendarLogo } from './google-calendar-logo';
export { SvgGrid } from './grid';
export { SvgGroupAdd } from './group-add';
export { SvgHelp } from './help';
export { SvgHelpCircle } from './help-circle';
export { SvgHighlightOff } from './highlight-off';
export { SvgHighlightText } from './highlight-text';
export { SvgHome } from './home';
export { SvgImage } from './image';
export { SvgImageInline } from './image-inline';
export { SvgImageStrikethrough } from './image-strikethrough';
export { SvgImage1 } from './image1';
export { SvgImage2 } from './image2';
export { SvgImport } from './import';
export { SvgInfo } from './info';
export { SvgInfoFill } from './info-fill';
export { SvgInfoOutline } from './info-outline';
export { SvgItalics } from './italics';
export { SvgAirtable } from './airtable';
export { SvgBitbucket } from './bitbucket';
export { SvgCoda } from './coda';
export { SvgFigma } from './figma';
export { SvgGithub } from './github';
export { SvgGoogleDocs } from './google_docs';
export { SvgGoogleSheets } from './google_sheets';
export { SvgGoogleDrive } from './google_drive';
export { SvgGoogleForms } from './google_forms';
export { SvgGoogleSlides } from './google_slides';
export { SvgNotion } from './notion';
export { SvgMicrosoftExcel } from './microsoft_excel';
export { SvgMicrosoftOneNote } from './microsoft_one_note';
export { SvgMicrosoftWord } from './microsoft_word';
export { SvgMicrosoftPowerpoint } from './microsoft_powerpoint';
export { SvgLucidchart } from './lucidchart';
export { SvgJira } from './jira';
export { SvgJiraNeutral } from './jira-neutral';
export { SvgKeyboardArrowDown } from './keyboard-arrow-down';
export { SvgKeyboardArrowLeft } from './keyboard-arrow-left';
export { SvgKeyboardArrowRight } from './keyboard-arrow-right';
export { SvgKeyboardArrowUp } from './keyboard-arrow-up';
export { SvgLaunch } from './launch';
export { SvgLightbulbOutline } from './lightbulb-outline';
export { SvgLinearDark } from './linearDark';
export { SvgLineThickness } from './line-thickness';
export { SvgLink } from './link';
export { SvgLinkBroken } from './link-broken';
export { SvgLinkedIn } from './linkedin';
export { SvgLinkOff } from './link-off';
export { SvgList } from './list';
export { SvgLock } from './lock';
export { SvgLockFill } from './lock-fill';
export { SvgLockUnlocked } from './lock-unlocked';
export { SvgLogOut } from './log-out';
export { SvgMail } from './mail';
export { SvgMaximize } from './maximize';
export { SvgMenu } from './menu';
export { SvgMenuHide } from './menu-hide';
export { SvgMenuShow } from './menu-show';
export { SvgMegaphone } from './megaphone';
export { SvgMic } from './mic';
export { SvgMicOff } from './mic-off';
export { SvgMicrosoftTeamsLogo } from './microsoft-teams-logo';
export { SvgMinimize } from './minimize';
export { SvgMinus } from './minus';
export { SvgMinusCircle } from './minus-circle';
export { SvgMobileDevices } from './mobile-devices';
export { SvgMoney } from './money';
export { SvgMoon } from './moon';
export { SvgMoreHoriz } from './more-horiz';
export { SvgMovieFilter } from './movie-filter';
export { SvgMute } from './mute';
export { SvgNearMe } from './near-me';
export { SvgNotes } from './notes';
export { SvgNotifications } from './notifications';
export { SvgNumberedList } from './numbered-list';
export { SvgOfflineBolt } from './offline-bolt';
export { SvgOutlook } from './outlook';
export { SvgOverlays } from './overlays';
export { SvgPaintBucket } from './paint-bucket';
export { SvgPalette } from './palette';
export { SvgPause } from './pause';
export { SvgPeople } from './people';
export { SvgPerson } from './person';
export { SvgPhotoSizeSelectActual } from './photo-size-select-actual';
export { SvgPictureInPicture } from './picture-in-picture';
export { SvgPin } from './pin';
export { SvgPinFill } from './pin-fill';
export { SvgPlay } from './play';
export { SvgPlayArrow } from './play-arrow';
export { SvgPlayCircle } from './play-circle';
export { SvgPlayCircleFilled } from './play-circle-filled';
export { SvgPlusCircle } from './plus-circle';
export { SvgPower } from './power';
export { SvgPresent } from './present';
export { SvgPresenterMode } from './presenter-mode';
export { SvgPronunciation } from './pronunciation';
export { SvgPublicOff } from './public-off';
export { SvgPublicOn } from './public-on';
export { SvgPublicon } from './publicon';
export { SvgPullRequest } from './pull-request';
export { SvgQuickEdit } from './quick-edit';
export { SvgRecord } from './record';
export { SvgRedo } from './redo';
export { SvgRedoAlt } from './redo-alt';
export { SvgRefresh } from './refresh';
export { SvgRemoveCircleOutline } from './remove-circle-outline';
export { SvgRemoveRedEye } from './remove-red-eye';
export { SvgRepeat } from './repeat';
export { SvgReplay } from './replay';
export { SvgReplay5 } from './replay-5';
export { SvgReply } from './reply';
export { SvgReplyLeft } from './reply-left';
export { SvgReplyRight } from './reply-right';
export { SvgRewind } from './rewind';
export { SvgRotateLeft } from './rotate-left';
export { SvgRovo } from './rovo';
export { SvgSafariLogo } from './safari-logo';
export { SvgSalesforce } from './salesforce';
export { SvgSalesforceBlk } from './salesforce-blk';
export { SvgSchool } from './school';
export { SvgScissors } from './scissors';
export { SvgScreenCam } from './screen-cam';
export { SvgSearch } from './search';
export { SvgSend } from './send';
export { SvgSentimentDissatisfied } from './sentiment-dissatisfied';
export { SvgSentimentSatisfied } from './sentiment-satisfied';
export { SvgSettings } from './settings';
export { SvgShare } from './share';
export { SvgShowChart } from './show-chart';
export { SvgSilenceRemoval } from './silence-removal';
export { SvgSkipBack } from './skip-back';
export { SvgSlack } from './slack';
export { SvgSmile } from './smile';
export { SvgSmileAlt } from './smile-alt';
export { SvgSmileSelect } from './smile-select';
export { SvgSquare } from './square';
export { SvgSpaces } from './spaces';
export { SvgSparkle } from './sparkle';
export { SvgSpeedFast } from './speed-fast';
export { SvgSpeedMedium } from './speed-medium';
export { SvgSpeedSlow } from './speed-slow';
export { SvgSpeedXFast } from './speed-x-fast';
export { SvgSpeedXSlow } from './speed-x-slow';
export { SvgSplit } from './split';
export { SvgStar } from './star';
export { SvgStarOutline } from './star-outline';
export { SvgStop } from './stop';
export { SvgSuggestedEdit } from './suggested-edit';
export { SvgSun } from './sun';
export { SvgTagFaces } from './tag-faces';
export { SvgTask } from './task';
export { SvgTeamworkAgentBig } from './teamwork-agent-big';
export { SvgTeamworkAgentSmall } from './teamwork-agent-small';
export { SvgTeamworkGraph } from './teamwork-graph';
export { SvgText } from './text';
export { SvgTextRephrase } from './text-rephrase';
export { SvgThumbsDown } from './thumbs-down';
export { SvgThumbsUp } from './thumbs-up';
export { SvgTimelineEditor } from './timeline-editor';
export { SvgTimer } from './timer';
export { SvgTouchApp } from './touch-app';
export { SvgTranscript } from './transcript';
export { SvgTrash } from './trash';
export { SvgTrashForever } from './trash-forever';
export { SvgTrelloNeutral } from './trello-neutral';
export { SvgTrello } from './trello';
export { SvgTune } from './tune';
export { SvgUnderline } from './underline';
export { SvgUndo } from './undo';
export { SvgUndoAlt } from './undo-alt';
export { SvgUpload } from './upload';
export { SvgUser } from './user';
export { SvgUsers } from './users';
export { SvgUsersAdd } from './users-add';
export { SvgVariables } from './variables';
export { SvgVersionControl } from './version-control';
export { SvgVerticalAlignBottom } from './vertical-align-bottom';
export { SvgVideoCam } from './video-cam';
export { SvgVideocam } from './videocam';
export { SvgVideocamOff } from './videocam-off';
export { SvgVideoLibrary } from './video-library';
export { SvgVideoOff } from './video-off';
export { SvgViewList } from './view-list';
export { SvgVolume1 } from './volume1';
export { SvgVolume2 } from './volume2';
export { SvgVolumeDown } from './volume-down';
export { SvgVolumeMute } from './volume-mute';
export { SvgVolumeOff } from './volume-off';
export { SvgVolumeUp } from './volume-up';
export { SvgVolumeX } from './volume-x';
export { SvgWarningAlert } from './warning-alert';
export { SvgWarningAmber } from './warning-amber';
export { SvgWatchLater } from './watch-later';
export { SvgWatchLaterAdded } from './watch-later-added';
export { SvgWatchLaterRemove } from './watch-later-remove';
export { SvgWaveform } from './waveform';
export { SvgWindow } from './window';
export { SvgWindows } from './windows';
export { SvgWriteDocument } from './write-document';
export { SvgWriteMessage } from './write-message';
export { SvgXCircle } from './x-circle';
export { SvgXLogo } from './x-twitter';
export { SvgZap } from './zap';
export { SvgZapOutline } from './zap-outline';
export { SvgZoomIn } from './zoom-in';
export { SvgZoomLogo } from './zoom-logo';
export { SvgZoomOut } from './zoom-out';
